<po-page-default p-title="Razão Contábil - Domínio" [p-breadcrumb]="breadcrumb"
    p-subtitle="Gere o relatório de Razão Contábil baseado nas informações da base de dados do sistema Domínio.">

    <!-- Resumo da página -->
    <div class="page-summary">
        <div class="page-summary-icon">
            <i class="an an-chart-line-up"></i>
        </div>
        <div class="page-summary-text">
            <p class="po-font-subtitle po-mb-0">Relatório de Razão Contábil</p>
            <p class="page-summary-hint">Selecione a empresa, contas e período para gerar o relatório que será enviado por e-mail.</p>
        </div>
    </div>

    <po-divider></po-divider>

    <form #form="ngForm" (ngSubmit)="requestRazaoContabil(form)">

        <!-- Seção: Configurações -->
        <div class="rpt-section po-mt-3">
            <div class="rpt-section-header">
                <i class="an an-gear-six"></i>
                <span>Configurações do Relatório</span>
            </div>
            <div class="rpt-section-body">
                <div class="po-row">
                    <app-empresa-combo class="po-lg-4 po-md-6 po-sm-12" name="idEmpresa" [(ngModel)]="idEmpresa"
                        label="Empresa" p-required="true"
                        placeholder="Buscar por código ou nome da empresa..."
                        help="Digite o código (Domínio) ou o nome da empresa para buscar.">
                    </app-empresa-combo>
                    <po-input class="po-lg-4 po-md-6 po-sm-12" p-label="Conta Inicial" name="contaInicial" p-pattern="^\d+$"
                        p-icon="an an-currency-circle-dollar" [(ngModel)]="contaInicial"
                        p-placeholder="Conta Inicial" p-help="Conta inicial considerada na geração do relatório"
                        p-required="true" p-name="contaInicial">
                    </po-input>
                    <po-input class="po-lg-4 po-md-6 po-sm-12" name="contaFinal" p-pattern="^\d+$" [(ngModel)]="contaFinal"
                        p-icon="an an-currency-circle-dollar" p-label="Conta Final" p-placeholder="Conta Final"
                        p-help="Conta final considerada na geração do relatório" p-required="true"
                        p-name="contaFinal">
                    </po-input>
                </div>
                <div class="po-row">
                    <po-datepicker-range class="po-lg-4 po-md-6 po-sm-12" p-label="Período" p-name="periodo"
                        name="periodo" [(ngModel)]="periodo" p-placeholder-start="Data Inicial"
                        p-placeholder-end="Data Final" p-help="Informe o período desejado para o relatório"
                        [p-required]="true">
                    </po-datepicker-range>
                </div>

                <div class="rpt-action-row po-mt-3">
                    <po-button p-label="Gerar Razão Contábil" p-icon="an an-paper-plane-tilt"
                        (p-click)="requestRazaoContabil(form)">
                    </po-button>
                </div>
            </div>
        </div>

        <!-- Seção: Como funciona -->
        <div class="rpt-section po-mt-3">
            <div class="rpt-section-header">
                <i class="an an-info"></i>
                <span>Como funciona</span>
            </div>
            <div class="rpt-section-body">
                <div class="rpt-info-steps">
                    <div class="rpt-info-step">
                        <div class="rpt-step-number">1</div>
                        <div class="rpt-step-content">
                            <p class="rpt-step-title">Preencha os campos</p>
                            <p class="rpt-step-desc">Selecione a empresa, informe as contas inicial/final e o período desejado.</p>
                        </div>
                    </div>
                    <div class="rpt-info-step">
                        <div class="rpt-step-number">2</div>
                        <div class="rpt-step-content">
                            <p class="rpt-step-title">Processamento automático</p>
                            <p class="rpt-step-desc">O sistema utilizará as informações do banco de dados do Domínio para gerar o relatório de Razão Contábil.</p>
                        </div>
                    </div>
                    <div class="rpt-info-step">
                        <div class="rpt-step-number">3</div>
                        <div class="rpt-step-content">
                            <p class="rpt-step-title">Receba por e-mail</p>
                            <p class="rpt-step-desc">Após o processamento, o relatório será enviado para o e-mail cadastrado em seu usuário. O processo pode levar alguns minutos.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </form>
